import React, { useEffect, useState } from "react";
import NavBar from "./NavBar";
import Footer from "./Footer";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { InfoIcon, Plus } from "lucide-react";
import InputPesquisa from "../components/Inputs/InputPesquisa";
import Loading from "./Loading";

const API_URL =
  process.env.REACT_APP_API_URL ||
  (typeof window !== "undefined" && window.location.hostname === "localhost"
    ? "http://localhost:8002"
    : "https://api-eyazs-production-8f74.up.railway.app");

export default function Clientes() {
  const [usuarios, setUsuarios] = useState([]);
  const [pesquisa, setPesquisa] = useState([]);
  const [usuario, setUsuario] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  function planoParaAdmin(cliente) {
    return cliente?.name?.trim().toLowerCase() === "adanca"
      ? cliente.profileusuario || "-"
      : cliente.profile || "-";
  }

  async function mostrarUsuarios() {
    try {
      setLoading(true)
      const token = JSON.parse(localStorage.getItem("token"));
      const dados = await axios.get(
        `${API_URL}/admin/clientes`,
        {
          headers: {
            'Authorization': `Bearer ${token}`,  // Substitua pelo seu token de autenticação
            'Content-Type': 'application/json'         // Define o tipo de conteúdo como JSON
          }
        }
      );      
      if (dados) {
        const listaOrdenada = dados.data.sort((a, b) =>
          a.name.localeCompare(b.name)
        );
        setUsuarios(listaOrdenada);
      } else {
        console.log("Usuarios Não Encontrados!");
      }
    } catch (erro) {
      console.log(erro);
    }finally{
      setLoading(false)
    }
  }

  async function mostrarPesquisa() {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const dadosPesquisa = await axios.post(
        `${API_URL}/pesquisarcliente`,
        {
          username: usuario,  // Passando o dado no corpo da requisição
        },
        {
          headers: {
            'Authorization': `Bearer ${token}`,  // Substitua pelo seu token de autenticação, se necessário
            'Content-Type': 'application/json'         // Define o tipo de conteúdo como JSON
          }
        }
      );      
      if (dadosPesquisa.data[0]) {
        setPesquisa(dadosPesquisa.data);
      }
    } catch (erro) {
      console.log(erro);
    }
  }

  useEffect(() => {
    if (usuario) {
      mostrarPesquisa();
    } else {
      setPesquisa([]);
    }
  }, [usuario]);

  useEffect(() => {
    mostrarUsuarios();
  }, []);

  const propsInputPesquisa = {
    type: "search",
    mudar: (e) => setUsuario(e.target.value),
    placeholder: "pesquise o usuário",
    value: usuario,
  };

  return (
    <div className="flex justify-between flex-col min-h-screen">
      <div className="bg-blue-500 sticky top-0 z-10">
        <NavBar />
      </div>
      {loading ? (
        <div className="z-0">
          <Loading />
        </div>
      ) : (
        <div className="flex flex-col items-center px-4 py-8 z-0">
          <div className="w-full max-w-5xl flex flex-col gap-4">
            <InputPesquisa {...propsInputPesquisa} />

            <div className="border w-full overflow-auto rounded-md">
              {pesquisa.length > 0 ? (
                <table className="min-w-full text-sm text-left text-gray-500">
                  <thead className="bg-gray-200 sticky top-0">
                    <tr>
                      <th className="border px-4 py-2 text-center">Ordem</th>
                      <th className="border px-4 py-2 text-center">Nome</th>
                      <th className="border px-4 py-2 text-center">Estado</th>
                      <th className="border px-4 py-2 text-center">Plano</th>
                      <th className="border px-4 py-2 text-center">Serviço</th>
                      <th className="border px-4 py-2 text-center">
                        Info. Cliente
                      </th>
                      <th className="border px-4 py-2 text-center">Recibos</th>
                      <th className="border px-4 py-2 text-center">
                        Adicionar
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {pesquisa.map((usuario, i) => (
                      <tr key={i} className="hover:bg-gray-100">
                        <td className="border px-4 py-2 text-center">
                          {i + 1}
                        </td>
                        <td className="border px-4 py-2 text-center">
                          {usuario.name}
                        </td>
                        <td className="border px-4 py-2 text-center">
                          {usuario.disabled === "false"
                            ? "Ativo"
                            : "Desativado"}
                        </td>
                        <td className="border px-4 py-2 text-center">
                          {planoParaAdmin(usuario)}
                        </td>
                        <td className="border px-4 py-2 text-center">
                          {usuario.service}
                        </td>
                        <td className="border px-4 py-2 text-center">
                          <InfoIcon
                            size={22}
                            className="mx-auto cursor-pointer hover:text-blue-500"
                            onClick={() => {
                              navigate(`detalhesusuario/${usuario.idUsuario}`);
                            }}
                          />
                        </td>
                        <td className="border px-4 py-2 text-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="w-6 h-6 mx-auto cursor-pointer hover:text-blue-500"
                            onClick={() => {
                              navigate(`recibosusuario/${usuario.idUsuario}`);
                            }}
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m.75 12 3 3m0 0 3-3m-3 3v-6m-1.5-9H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
                            />
                          </svg>
                        </td>
                        <td className="border px-4 py-2 text-center">
                          <Plus
                            className="mx-auto cursor-pointer hover:text-blue-500"
                            onClick={() => {
                              navigate(`adicionarcliente/${usuario.idUsuario}`);
                            }}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <table className="min-w-full text-sm text-left text-gray-500">
                  <thead className="bg-gray-200">
                    <tr>
                      <th className="border px-4 py-2 text-center">Ordem</th>
                      <th className="border px-4 py-2 text-center">Nome</th>
                      <th className="border px-4 py-2 text-center">Estado</th>
                      <th className="border px-4 py-2 text-center">Plano</th>
                      <th className="border px-4 py-2 text-center">Serviço</th>
                      <th className="border px-4 py-2 text-center">
                        Info. Cliente
                      </th>
                      <th className="border px-4 py-2 text-center">Recibos</th>
                      <th className="border px-4 py-2 text-center">
                        Adicionar
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {usuarios.map((usuario, i) => (
                      <tr key={i} className="hover:bg-gray-100">
                        <td className="border px-4 py-2 text-center">
                          {i + 1}
                        </td>
                        <td className="border px-4 py-2 text-center">
                          {usuario.name}
                        </td>
                        <td className="border px-4 py-2 text-center">
                          {usuario.disabled === "false"
                            ? "Ativo"
                            : "Desativado"}
                        </td>
                        <td className="border px-4 py-2 text-center">
                          {planoParaAdmin(usuario)}
                        </td>
                        <td className="border px-4 py-2 text-center">
                          {usuario.service}
                        </td>
                        <td className="border px-4 py-2 text-center">
                          <InfoIcon
                            size={22}
                            className="mx-auto cursor-pointer hover:text-blue-500"
                            onClick={() => {
                              navigate(`detalhesusuario/${usuario.idUsuario}`);
                            }}
                          />
                        </td>
                        <td className="border px-4 py-2 text-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="w-6 h-6 mx-auto cursor-pointer hover:text-blue-500"
                            onClick={() => {
                              navigate(`recibosusuario/${usuario.idUsuario}`);
                            }}
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m.75 12 3 3m0 0 3-3m-3 3v-6m-1.5-9H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
                            />
                          </svg>
                        </td>
                        <td className="border px-4 py-2 text-center">
                          <Plus
                            className="mx-auto cursor-pointer hover:text-blue-500"
                            onClick={() => {
                              navigate(`adicionarcliente/${usuario.idUsuario}`);
                            }}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      )}
      <div className="bg-blue-500 w-full">
        <Footer />
      </div>
    </div>
  );
}
